/**
 * SPA-11: which school's own website content the tenant chrome may show. The footer's logo,
 * "about" blurb, address, phones, social and legal links are Astromania's — every other tenant
 * gets a footer built from its own name and logo. Presentation only, not an authorisation rule.
 */
export const ASTROMANIA_TENANT_SLUG = "astromania";

export function showsAstromaniaSiteFooter(tenantSlug: string | null | undefined): boolean {
  return (tenantSlug ?? "").trim().toLowerCase() === ASTROMANIA_TENANT_SLUG;
}
